import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CachePlanSelection as CachePlanSelectionMutation,
    CachePlanSelectionVariables as CachePlanSelectionVariables,
    CachePlanSelectionInput,
} from 'nutshell-graphql-types';

import CACHE_PLAN_SELECTION from '../mutations/cache-plan-selection.graphql';

export const useCachePlanSelection = (): {
    cachePlanSelection: (arg1: CachePlanSelectionInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [cachePlanSelection, {loading, error}] = useMutation<
        CachePlanSelectionMutation,
        CachePlanSelectionVariables
    >(CACHE_PLAN_SELECTION);

    return {
        cachePlanSelection: (input: CachePlanSelectionInput) =>
            cachePlanSelection({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
